import React from 'react'
import LoginUser from './Login/LoginUser'
// import LoginRegisterUser from '../LoginRegisterUser';

const Login = () => {
  return (
    <div>
      {/* <LoginRegisterUser /> */}
      <LoginUser />
    </div>
  )
}

export default Login
